/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedCreatorSpotlightProductTile_edge$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespCreatorSpotlightModule_collectionsModules$ref: FragmentReference;
export type SbRespCreatorSpotlightModule_collectionsModules = {|
  +title: ?string,
  +photo: ?string,
  +description: ?string,
  +link: ?string,
  +linkText: ?string,
  +itemsConnection: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +serviceId: ?string
      |},
      +$fragmentRefs: SbSharedCreatorSpotlightProductTile_edge$ref,
    |}>
  |},
  +$refType: SbRespCreatorSpotlightModule_collectionsModules$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespCreatorSpotlightModule_collectionsModules",
  "type": "CollectionsModulesCreatorSpotlight",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "photo",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "link",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "linkText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "itemsConnection",
      "storageKey": null,
      "args": null,
      "concreteType": "CmsItemsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CmsItemsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedCreatorSpotlightProductTile_edge",
              "args": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c34945bef02973a5286bfa24baa69612';
module.exports = node;
